import { CartAddEvent } from '@theme/events';

function getCartSectionIds() {
  const sectionIds = new Set();
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((item) => {
    if (item instanceof HTMLElement && item.dataset.sectionId) {
      sectionIds.add(item.dataset.sectionId);
    }
  });
  return Array.from(sectionIds);
}

function dispatchCartUpdate(variantId, productId, responseData) {
  document.dispatchEvent(
    new CartAddEvent(responseData || {}, String(variantId || 'sam-tag-cart-recommendations'), {
      source: 'sam-tag-cart-recommendations',
      itemCount: 1,
      productId: String(productId || ''),
      variantId: String(variantId || ''),
      sections: responseData && responseData.sections ? responseData.sections : undefined,
    })
  );
}

async function addRecommendationToCart(button) {
  const card = button.closest('.sam-tag-cart-rec__card');
  const variantSelect = card ? card.querySelector('[data-sam-tag-cart-rec-variant]') : null;
  const variantId = Number((variantSelect && variantSelect.value) || button.dataset.variantId);
  const productId = button.dataset.productId || '';
  if (!variantId || button.disabled) return;

  const defaultText = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding';

  try {
    const sectionIds = getCartSectionIds();
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => '');
      throw new Error(`Cart error: ${response.status} ${errorText}`);
    }

    const responseData = await response.json();
    dispatchCartUpdate(variantId, productId, responseData);
    button.textContent = 'Added';
  } catch (error) {
    console.error('[SamTagCartRecommendations] Add to cart failed:', error);
    button.disabled = false;
    button.textContent = 'Try again';
    window.setTimeout(() => {
      if (!button.disabled) button.textContent = defaultText;
    }, 1800);
    return;
  }

  window.setTimeout(() => {
    button.disabled = false;
    button.textContent = defaultText;
  }, 1200);
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('[data-sam-tag-cart-rec-add]');
  if (!(button instanceof HTMLButtonElement)) return;

  event.preventDefault();
  addRecommendationToCart(button);
});

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const select = target.closest('[data-sam-tag-cart-rec-variant]');
  if (!(select instanceof HTMLSelectElement)) return;

  const card = select.closest('.sam-tag-cart-rec__card');
  const button = card ? card.querySelector('[data-sam-tag-cart-rec-add]') : null;
  const price = card ? card.querySelector('[data-sam-tag-cart-rec-price]') : null;
  const image = card ? card.querySelector('[data-sam-tag-cart-rec-image]') : null;
  const selectedOption = select.selectedOptions && select.selectedOptions[0];

  if (button instanceof HTMLButtonElement) {
    button.dataset.variantId = select.value;
  }

  if (price && selectedOption && selectedOption.dataset.price) {
    price.textContent = selectedOption.dataset.price;
  }

  if (image instanceof HTMLImageElement && selectedOption && selectedOption.dataset.image) {
    image.src = selectedOption.dataset.image;
    if (selectedOption.dataset.imageSrcset) {
      image.srcset = selectedOption.dataset.imageSrcset;
    }
  }
});
